module.exports = __webpack_public_path__ + "img/badge-vr.08e61b52.svg";